import Head from 'next/head';
import type { FC } from 'react';

export const Meta: FC<{ title: string; desc: string; hero: string }> = ({ title, desc, hero }) => {
  // https://github.com/vercel/next.js/discussions/38256#discussioncomment-3070196
  const parsedTitle = `${title} | Motimate`;
  return (
    <Head>
      <title>{parsedTitle}</title>
      <link rel="icon" href="/favicon.png" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content={desc} />
      <meta property="og:title" content={parsedTitle} />
      <meta property="og:site_property" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={hero} />
      <meta name="twitter:title" content={`${title} | Motimate`} />
      <meta name="twitter:image" content={hero} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:description" content={desc} />
      <meta itemProp="thumbnailUrl" content={hero} />
      <meta itemProp="image" content={hero} />
      <meta itemProp="name" content={title} />
    </Head>
  );
};
